import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'form-field-error-below',
  templateUrl: './form-field-error-below.component.html',
  standalone: false
})
export class FormFieldErrorBelowComponent {
  @Input()
    control: UntypedFormControl = null;

  get hasError(): boolean {
    if (this.control === null || this.control.errors === null) {
      return false;
    }

    return Object.keys(this.control.errors).length > 0;
  }

  get errorMessages(): string[] {
    const errors: string[] = [];

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const propertyName in this.control.errors) {
      const error = this.control.getError(propertyName);

      // If control has a error return the appropriate error message from the Validation Service
      if (this.control.dirty || propertyName === 'required') {
        if (propertyName === 'required') {
          errors.push('Required');
        } else if (propertyName === 'pattern' || propertyName === 'minlength') {
          errors.push('Please enter valid input');
        } else if (propertyName === 'min') {
          errors.push(`Must be at least ${error.min}`);
        } else if (propertyName === 'mask') {
          const message = error.requiredMask ? `Expected format: ${error.requiredMask}` : 'Invalid format';
          errors.push(message);
        } else {
          errors.push(error);
        }
      }
    }

    return errors;
  }
}
